<mat-drawer-container>
  <mat-drawer [mode]="(screenWidth > 800) ? 'side' : 'over'" [opened]="sideBarOpen">
    <app-inactive-side-nav></app-inactive-side-nav>
  </mat-drawer>

  <mat-drawer-content>
    <app-inactive-header (toggleSidebarForMe)="sideBarToggler()"></app-inactive-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </mat-drawer-content>

</mat-drawer-container>